import { DEEP_LINK_REPORT_IDS } from '@/components/reports/shared/deep-link-report-type';
import { NATIVE_REPORT_IDS } from '@/components/reports/shared/native-report-type';
import type { ReportType } from '@/types/generated/endpoints/reports';

export {
  DEEP_LINK_REPORT_LABEL_KEYS,
  NATIVE_REPORT_LABEL_KEYS,
  REPORT_TYPE_LABEL_KEYS,
} from '@/lib/enum-labels/report-type';

export const REPORT_TYPES = [
  'org_performance',
  'strategy',
  'platform_comparison',
  'budget_utilization',
  'top_performers',
  'recommendations_digest',
  'ai_performance',
  'attribution',
] as const satisfies readonly ReportType[];

export const CUSTOM_REPORT_ID = 'custom' as const satisfies ReportType;

export const ALL_REPORT_TYPES = [
  ...REPORT_TYPES,
  CUSTOM_REPORT_ID,
  ...NATIVE_REPORT_IDS,
  ...DEEP_LINK_REPORT_IDS,
] as const;
export type AnyReportId = (typeof ALL_REPORT_TYPES)[number];

// The generated ReportType also carries 'custom', which REPORT_TYPES deliberately excludes.
export type CuratedReportType = (typeof REPORT_TYPES)[number];
